import { IonList, IonItem, IonLabel } from "@ionic/react";
import React from "react";
import { useSelector } from "react-redux";
import { Organization } from "../../../@types/organization";
import { selectOrganizations } from "../../../store/organizations/selectors/selectOrganizations";

export const ListSection: React.FC = () => {
  const organizations = useSelector(selectOrganizations);

  /*   const ListItem = (childs: any) => (
    <>
      {(childs || []).map((location: Location) => (
        <>
          <IonItem routerLink={`/app/rrhh/locations/${location.id}`}>
            <IonLabel>
              <h3>{location.name}</h3>
            </IonLabel>
          </IonItem>
          {location.childs?.length && <ListItem childs={location.childs} />}
        </>
      ))}
    </>
  ); */
  return (
    <IonList>
      {/* <ListItem childs={locations} /> */}

      {organizations.map((organization: Organization, index) => (
        <IonItem
          key={`item-${index}`}
          routerLink={`/app/gerencia/mis-clientes/detalle/${organization.id}`}
        >
          <IonLabel>
            <h3>{organization.name}</h3>
          </IonLabel>
        </IonItem>
      ))}
    </IonList>
  );
};
